import { cn } from "@/lib/utils";

export function PageHeader({ 
  title, 
  description, 
  children, 
  className,
  breadcrumb 
}) {
  return (
    <div className={cn("mb-8", className)} data-testid="page-header">
      {breadcrumb && (
        <div className="mb-4">
          {breadcrumb}
        </div>
      )}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="shrink-0">
          <h1 className="text-3xl font-bold tracking-tight" data-testid="page-title">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-muted-foreground" data-testid="page-description">
              {description}
            </p>
          )}
        </div>
        {children && (
          <div className="flex items-center gap-3" data-testid="page-actions">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export function PageSection({ title, description, children, className }) {
  return (
    <section className={cn("space-y-4", className)}>
      {(title || description) && (
        <div>
          {title && (
            <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
          )}
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
